import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "sections"];
import { parse as parseParams } from 'hub-http/helpers/params';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getPageViewedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useEffect, useRef } from 'react';
import { useAppContext } from '../context/AppContext';
export function useTrackHomepageViewedEvent(_ref) {
  let {
      loading,
      sections
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const appContext = useAppContext();
  const params = parseParams(window.location.search.slice(1));
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const eventSentRef = useRef(false);
  useEffect(() => {
    if (!loading && !eventSentRef.current) {
      eventSentRef.current = true;
      const sectionStrings = sections === null || sections === void 0 ? void 0 : sections.map((section, index) => `${index}__${String(section.sectionType)}`);
      trackMarketplaceEvent(getPageViewedEvent(Object.assign({}, rest, {
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        sections: sectionStrings,
        embed: true,
        referrer: typeof params.referrer === 'string' ? params.referrer : undefined
      })));
    }
  }, [appContext, loading, params, rest, sections, trackMarketplaceEvent]);
}